module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-usage/cart-d84093c8afad47a608e8ae2b71c3777d.svg";